module.exports = __webpack_public_path__ + "static/media/drum3.dbcc18bc.ogg";